"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShippingKitStatus = void 0;
var ShippingKitStatus;
(function (ShippingKitStatus) {
    ShippingKitStatus["OPEN"] = "open";
    ShippingKitStatus["READY_FOR_PACKAGING"] = "ready-for-packaging";
    ShippingKitStatus["BEING_PACKAGED"] = "being-packaged";
    ShippingKitStatus["PACKAGED"] = "packaged";
})(ShippingKitStatus = exports.ShippingKitStatus || (exports.ShippingKitStatus = {}));
//# sourceMappingURL=shipping-kit-status.enum.js.map